import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { HistoricalValue } from '../../../types/historical-value';
import { getHistoricalValuesByUniqueIdFactory } from '../../../store/selectors/historical-values.selector';
import { ConnectivityService } from '@evorait/pace-core';
import { map } from 'rxjs/operators';
import { loadHistoricalValuesFromBackend } from '../../../store/actions/historical-values.actions';

@Component({
    selector: 'pace-forms-historical-values-modal',
    templateUrl: './historical-values-modal.component.html',
    styleUrl: './historical-values-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistoricalValuesModalComponent implements OnInit {
    @Input()
    public uniqueId: string;

    private readonly connectivityService = inject(ConnectivityService);
    public readonly modalInstance = inject(BsModalRef);
    private readonly store = inject(Store);
    public historicalValues$: Observable<HistoricalValue[]>;
    public disableLoadMoreButton$: Observable<boolean>;

    public constructor() {
        this.disableLoadMoreButton$ = this.connectivityService.isOnline$.pipe(map((isOnline) => !isOnline));
    }

    public ngOnInit(): void {
        const historicalValuesSelector = getHistoricalValuesByUniqueIdFactory({ uniqueId: this.uniqueId });
        this.historicalValues$ = this.store.select(historicalValuesSelector);
    }

    public loadAllValues(): void {
        this.store.dispatch(loadHistoricalValuesFromBackend({ uniqueId: this.uniqueId }));
    }
}
